import { default as calculationQm4IF33NW5Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailxIvwWlSCAQMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryFvPgioxo33Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93aw66RaN2EAMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45list3UbZOCxgJwMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingVK2boHvDNcMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyoutLwpxhFlKwMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsell2WfP7kdYPMMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadoste8XKbYKOJDMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankFHqCmbv7A4Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniTfy0gEkPacMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as page0TQdxpfQkbMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testSH8JtqioXmMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepage0hvQLWyHEgMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleAhk8JQ35gNMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternspBZxKdfUJZMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as taggVdtERIFUjMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorguYXR6q7CdMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryK8XZedm4G0Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as section6hw0BH1bPNMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesuZ9IMsnjXNMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryQ5xHQaiiPlMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleS8t1kCRbs6Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionCBLhJnx4oyMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactwVKg5bcbxlMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationwsoQTuRvp3Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationJWrDEYT3d2Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youDRuUCCKjTnMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailfjNKKlwknCMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiry3T9LC3xwoIMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listRDh4qY90w5Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationwaaAUOkYNbMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youVqiMkleTLLMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryW5HPFnF3D8Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45list5dsn4Dole6Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detail8qxpbouv17Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerL7NSmyfWotMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryd0NJS3vjQUMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youVecAer3mkcMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationdzHVa7XmGHMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listKTPPWuwG03Meta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youZpVdaPJrdgMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlinelEGUGbvspvMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailGWvH79rdXHMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phones4m9QMeGqQMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offer30uN5P2nxPMeta } from "/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani-ab/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadoste8XKbYKOJDMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankFHqCmbv7A4Meta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniTfy0gEkPacMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: page0TQdxpfQkbMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testSH8JtqioXmMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepage0hvQLWyHEgMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleAhk8JQ35gNMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternspBZxKdfUJZMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: taggVdtERIFUjMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorguYXR6q7CdMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryK8XZedm4G0Meta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: section6hw0BH1bPNMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesuZ9IMsnjXNMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: page0TQdxpfQkbMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryQ5xHQaiiPlMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleS8t1kCRbs6Meta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionCBLhJnx4oyMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionCBLhJnx4oyMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactwVKg5bcbxlMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationwsoQTuRvp3Meta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationJWrDEYT3d2Meta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youDRuUCCKjTnMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailfjNKKlwknCMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiry3T9LC3xwoIMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listRDh4qY90w5Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationwaaAUOkYNbMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youVqiMkleTLLMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryW5HPFnF3D8Meta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45list5dsn4Dole6Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detail8qxpbouv17Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerL7NSmyfWotMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryd0NJS3vjQUMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youVecAer3mkcMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationdzHVa7XmGHMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listKTPPWuwG03Meta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youZpVdaPJrdgMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlinelEGUGbvspvMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailGWvH79rdXHMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phones4m9QMeGqQMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offer30uN5P2nxPMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src3033201694/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]